import {
  IApiRequest,
  IApiResponse,
  ITenantHolidayGroupedResponse,
  ITenantHolidayResponse,
} from "@miplatform/types";
import {
  API_VERSION,
  CALENDAR_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_TENANT_HOLIDAYS = `${CALENDAR_SERVICE}/tenant-holidays`;

export const tenantHolidays = {
  getAll: async (
    config: IApiRequest = {}
  ): Promise<IApiResponse<ITenantHolidayResponse[]>> => {
    const options = await apiOptions({
      url: API_TENANT_HOLIDAYS,
      method: "get",
      ...config,
    });
    return apiRequest(options);
  },
  getAllGrouped: async (
    config: IApiRequest = {}
  ): Promise<IApiResponse<ITenantHolidayGroupedResponse[]>> => {
    const options = await apiOptions({
      url: `${API_TENANT_HOLIDAYS}/grouped`,
      method: "get",
      ...config,
    });
    return apiRequest(options);
  },
  get: async (id: string): Promise<IApiResponse<ITenantHolidayResponse>> => {
    const options = await apiOptions({
      url: `${API_TENANT_HOLIDAYS}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({
    data,
    toastMessageConfig,
  }: IApiRequest<ITenantHolidayResponse>): Promise<
    IApiResponse<ITenantHolidayResponse>
  > => {
    const options = await apiOptions({
      url: API_TENANT_HOLIDAYS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({
    id,
    data,
    toastMessageConfig,
  }: IApiRequest<ITenantHolidayResponse>): Promise<
    IApiResponse<ITenantHolidayResponse>
  > => {
    const options = await apiOptions({
      url: `${API_TENANT_HOLIDAYS}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({
    data,
    toastMessageConfig,
  }: IApiRequest<ITenantHolidayResponse>): Promise<IApiResponse<void>> => {
    const options = await apiOptions({
      url: `${API_TENANT_HOLIDAYS}/${data.id}`,
      method: "delete",
      data,
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
